import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `create`; also keeps `new` from being read as a template id.
export const Route = createFileRoute('/_authenticated/templates/flexible-calculation/new')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/templates/flexible-calculation/create', search: true, replace: true });
    },
});
